import React from "react"
import { Link, navigate } from "gatsby"
import "./service.css"

const extractPlainText = (richTextRaw) => {
  if (!richTextRaw) return ""
  try {
    const parsed = JSON.parse(richTextRaw)
    const extractText = (node) => {
      if (node.nodeType === "text") {
        return node.value || ""
      }
      if (node.content && Array.isArray(node.content)) {
        return node.content.map(extractText).join("")
      }
      return ""
    }
    return extractText(parsed)
  } catch (e) {
    return ""
  }
}

const Service = ({ data }) => {
    const formatPrice = (price) => {
        return new Intl.NumberFormat('es-MX', {
            style: 'currency',
            currency: 'MXN',
            minimumFractionDigits: 0
        }).format(price)
    }

    const handleServiceClick = (e, codigo) => {
        if (!e.target.closest('.ServiceCardLink')) {
            navigate(`/servicios/${codigo}`)
        }
    }

    return (
        <div className="Services" id="servicios">
            <div className="ServicesHeader">
                <h2 className="ServicesTitle">Nuestros Servicios</h2>
                <p className="ServicesSubtitle">Soluciones profesionales para ti</p>
            </div>
            <div className="ServicesGrid">
                {data.edges.map((edge, index) => {
                    const description = extractPlainText(edge.node.summary?.raw)

                    return (
                        <div
                            className="ServiceCard"
                            key={edge.node.codigo}
                            onClick={(e) => handleServiceClick(e, edge.node.codigo)}
                            style={{ animationDelay: `${index * 0.1}s` }}
                        >
                            <div className="ServiceCardImage">
                                <img
                                    src={edge.node.imagenes?.[0]?.file?.url || edge.node.bgImage?.file?.url}
                                    alt={edge.node.nombre}
                                />
                            </div>
                            <div className="ServiceCardContent">
                                <span className="ServiceCardBadge">Servicio</span>
                                <h3 className="ServiceCardTitle">{edge.node.nombre}</h3>
                                {description && (
                                    <p className="ServiceCardDescription">{description.substring(0, 150)}</p>
                                )}
                                <div className="ServiceCardFooter">
                                    <div className="ServiceCardPrice">
                                        <span className="ServiceCardPriceLabel">Desde</span>
                                        <span className="ServiceCardPriceValue">{formatPrice(edge.node.precio)}</span>
                                    </div>
                                    <Link
                                        to={`/servicios/${edge.node.codigo}`}
                                        className="ServiceCardLink"
                                        onClick={(e) => e.stopPropagation()}
                                    >
                                        Ver detalle
                                    </Link>
                                </div>
                            </div>
                        </div>
                    )
                })}
            </div>
        </div>
    )
}
export default Service
